import { createPlatePlugin } from 'platejs/react'
import type { AnyPlatePlugin } from 'platejs/react'

// NodeComponent isn't re-exported publicly at v42 (used internally by
// AnyPlatePlugin['node'] but not exported under its own name) — derive it
// structurally instead of importing it directly.
type NodeComponent = NonNullable<AnyPlatePlugin['node']>['component']

import type { BufferEditor } from '~publish/legacy/editor/BufferEditor/types.plate'
import type { BufferPluginOptions } from '~publish/legacy/editor/plugins/types'

import { LinkElement } from './nodes/LinkElement'
import { textToLinkNodes } from './transforms/textToLinkNodes'
import { LinkElementUI } from './ui/LinkElementUI'
import { withLinks } from './withLinks'

export type LinkPluginOptions = BufferPluginOptions & {
  enableLinkShortening?: boolean
}

export const LinkPluginKey = LinkElement.type

// Not returned directly from the arrow function: an explicit return type on
// the expression itself back-propagates into createPlatePlugin's own
// generic inference and corrupts it (options/node end up typed against the
// annotation's defaults instead of the literal passed in).
export const createLinkPlugin = (overrides?: {
  component?: NodeComponent
  options?: Partial<LinkPluginOptions>
}): AnyPlatePlugin => {
  const component = overrides?.component ?? LinkElementUI
  const plugin = createPlatePlugin({
    key: LinkElement.type,
    node: {
      isElement: true,
      isInline: true,
      component,
    },
    extendEditor: ({ editor }) => withLinks(editor as unknown as BufferEditor),
    options: {
      textToNodes: textToLinkNodes,
      ...overrides?.options,
    },
  })
  return plugin
}
